import { inject, Injectable } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { CloudDriveModalData, CloudDriveModalComponent } from 'app/app-modules/modal';
import { firstValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CloudDriveModalService {
  private readonly _translate = inject(TranslateService);

  private readonly _dialogService = inject(DialogService);

  open(data: CloudDriveModalData) {
    return firstValueFrom(
      this._dialogService.open(CloudDriveModalComponent, {
        data: data,
        header: this._translate.instant('general.cloudDrive'),
        showHeader: true,
        modal: true,
        closable: true,
        closeOnEscape: true,
        width: '80vw',
        height: '70vh',
        styleClass: 'cloud-drive-modal-dialog',
        contentStyle: {
          padding: 0,
          margin: 0,
          border: 'none',
          overflow: 'hidden',
          height: '100%',
        },
      }).onClose
    );
  }
}
